import { useContext } from 'react'

import { KpiLogisticContext } from '@provider/Kpi/LogisticProvider'

import { IKpiLogisticContext } from '@base/@types/providers/Kpi/LogisticProvider'

export default function useKpiLogistic(): IKpiLogisticContext {
  const context = useContext(KpiLogisticContext)

  return context
}
